import type { ReservationSlotTemplate } from '../../domain/reservationSlots';
import type { ReservationSlotTemplateRepository } from './ports/ReservationSlotTemplateRepository';

/**
 * 解放枠テンプレート一覧を取得するUseCase
 *
 * @param {ReservationSlotTemplateRepository} repository - Repository実装（DI）
 * @returns {Promise<ReservationSlotTemplate[]>} テンプレート配列
 */
export async function getTemplates(
  repository: ReservationSlotTemplateRepository
): Promise<ReservationSlotTemplate[]> {
  return repository.findAll();
}
